/* Screens laid over everything for a moment (see overlays.tsx). */

.kiln[hidden],
.iris[hidden],
.loading[hidden] {
  display: none;
}

.text {
  margin: 0;
  font-size: 14px;
  font-weight: 700;
  color: var(--ink-soft);
}

/* ---------- The paw prints while a stage is being made ready ---------- */

/* Laid over at once, so that nothing under it is touched meanwhile, but seen only should the
   stage take more than a moment: one taken on before is ready sooner, its meshes kept. */
.loading {
  position: fixed;
  inset: 0;
  display: grid;
  place-content: center;
  justify-items: center;
  gap: 10px;
  background: rgba(255, 246, 235, 0.55);
  backdrop-filter: blur(3px);
  z-index: 11;
  animation: loading-in 0.2s 0.4s both;
}

@keyframes loading-in {
  from {
    opacity: 0;
  }
}

/* ---------- The kiln, rising over the piece to fire it ---------- */

.kiln {
  position: fixed;
  inset: 0;
  display: grid;
  place-items: end center;
  overflow: hidden;
  pointer-events: none;
}

.kilnBody {
  position: relative;
  display: grid;
  place-items: center;
  width: min(88vw, 80dvh);
  height: 94dvh;
  border-radius: 48% 48% 18px 18px / 36% 36% 18px 18px;
  background: linear-gradient(#946350, #5e3c2f);
  box-shadow: inset 0 -24px 40px rgba(0, 0, 0, 0.25), 0 12px 40px rgba(90, 50, 30, 0.35);
  transform: translateY(110%);
}

.mouth {
  position: relative;
  width: 58%;
  height: 44%;
  overflow: hidden;
  border-radius: 50% 50% 12px 12px / 60% 60% 12px 12px;
  background: #2a1712;
  box-shadow: inset 0 0 30px rgba(0, 0, 0, 0.6);
}

.fire {
  position: absolute;
  inset: 18% 8% -12%;
  background: radial-gradient(60% 70% at 50% 100%, #fff3b0, #ffb347 35%, #ff6a2b 60%, transparent
    75%);
  filter: blur(4px);
  transform-origin: 50% 100%;
  animation: flicker 0.35s ease-in-out infinite alternate;
}

@keyframes flicker {
  from {
    transform: scale(1.05, 0.85);
    opacity: 0.85;
  }
  to {
    transform: scale(0.95, 1.1);
    opacity: 1;
  }
}

.kilnText {
  position: absolute;
  bottom: 9%;
  margin: 0;
  color: #fbe1d1;
  font-size: 16px;
  font-weight: 700;
}

/* ---------- The cat-face iris, closing on non-kiln materials ---------- */

/* The screen with a cat face cut out of it: the face shrinks to nothing, and grows back. */
.iris {
  position: fixed;
  inset: 0;
  display: grid;
  place-content: center;
  justify-items: center;
  gap: 10px;
  background: #eef4fa;
  mask-image:
    url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 100 100'%3E%3Cg fill='black' stroke='black' stroke-width='6' stroke-linejoin='round'%3E%3Cellipse cx='50' cy='60' rx='40' ry='33'/%3E%3Cpath d='M14 50 19 10 45 31Z M86 50 81 10 55 31Z'/%3E%3C/g%3E%3C/svg%3E"),
    linear-gradient(#000 0 0);
  mask-composite: exclude;
  mask-repeat: no-repeat;
  mask-position: center;
  mask-size: 400vmax 400vmax, 100% 100%;
  pointer-events: none;
  z-index: 12;
}

/* The cover in the colour of the finish. */
.iris[data-cover="plastic"] {
  background: #eaf6ec;
}

.iris[data-cover="wood"] {
  background: #f3e7d8;
}

.iris[data-cover="metal"] {
  background: #eceef1;
}

.iris .text {
  font-size: 16px;
}
